import React from 'react';
import { cn } from '../utils/cn';
/**
 * Branded payment-method logos rendered as inline SVGs on white chips.
 * Used in the Hero and the OfferCard so the accepted payments read as real
 * card brands instead of plain text.
 */
function Chip({
  children,
  label
}: {
  children: React.ReactNode;
  label: string;
}) {
  return <span role="img" aria-label={label} className="inline-flex h-8 w-12 sm:h-9 sm:w-14 items-center justify-center rounded-md bg-white px-2 shadow-sm ring-1 ring-black/5" data-id="element-146">
      {children}
    </span>;
}
function VisaLogo() {
  return <svg viewBox="0 0 48 16" className="h-3 sm:h-3.5 w-auto" aria-hidden="true" data-id="element-147">
      <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="700" fontStyle="italic" fontSize="15" fill="#1A1F71" letterSpacing="0.5" data-id="element-148">
        VISA
      </text>
    </svg>;
}
function MastercardLogo() {
  return <svg viewBox="0 0 36 24" className="h-5 sm:h-6 w-auto" aria-hidden="true" data-id="element-149">
      <circle cx="13" cy="12" r="9" fill="#EB001B" data-id="element-150" />
      <circle cx="23" cy="12" r="9" fill="#F79E1B" data-id="element-151" />
      <path d="M18 5.2a8.97 8.97 0 0 1 0 13.6 8.97 8.97 0 0 1 0-13.6Z" fill="#FF5F00" data-id="element-152" />
    </svg>;
}
function AmexLogo() {
  return <svg viewBox="0 0 40 24" className="h-5 sm:h-6 w-auto" aria-hidden="true" data-id="element-153">
      <rect width="40" height="24" rx="3" fill="#006FCF" data-id="element-154" />
      <text x="20" y="11" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="6" fill="#fff" data-id="element-155">
        AMERICAN
      </text>
      <text x="20" y="18" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="6" fill="#fff" data-id="element-156">
        EXPRESS
      </text>
    </svg>;
}
function ApplePayLogo() {
  return <svg viewBox="0 0 40 18" className="h-4 sm:h-5 w-auto" aria-hidden="true" data-id="element-157">
      <path d="M7.6 4.2c-.5.6-1.3 1-2 .95-.1-.78.28-1.6.74-2.12C6.85 2.4 7.7 2.03 8.4 2c.08.82-.25 1.62-.8 2.2Zm.78 1.24c-1.1-.06-2.05.62-2.58.62-.54 0-1.35-.59-2.23-.57-1.15.02-2.2.66-2.79 1.69-1.2 2.06-.31 5.12.85 6.8.57.82 1.24 1.74 2.13 1.7.85-.03 1.18-.55 2.2-.55 1.03 0 1.32.55 2.22.53.92-.02 1.5-.83 2.06-1.66.65-.95.92-1.87.93-1.92-.02-.01-1.78-.69-1.8-2.72-.02-1.7 1.38-2.51 1.45-2.55-.79-1.17-2.02-1.3-2.46-1.33Z" fill="#000" data-id="element-158" />
      <text x="14.5" y="13" fontFamily="Arial, sans-serif" fontWeight="600" fontSize="9" fill="#000" data-id="element-159">
        Pay
      </text>
    </svg>;
}
function GooglePayLogo() {
  return <svg viewBox="0 0 48 18" className="h-4 sm:h-5 w-auto" aria-hidden="true" data-id="element-160">
      <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="11" data-id="element-161">
        <tspan fill="#4285F4" data-id="element-162">G</tspan>
        <tspan fill="#EA4335" data-id="element-163">o</tspan>
        <tspan fill="#FBBC04" data-id="element-164">o</tspan>
        <tspan fill="#4285F4" data-id="element-165">g</tspan>
        <tspan fill="#34A853" data-id="element-166">l</tspan>
        <tspan fill="#EA4335" data-id="element-167">e</tspan>
      </text>
      <text x="33" y="13" fontFamily="Arial, sans-serif" fontWeight="600" fontSize="11" fill="#5F6368" data-id="element-168">
        Pay
      </text>
    </svg>;
}
const methods = [{
  label: 'Visa',
  Logo: VisaLogo
}, {
  label: 'Mastercard',
  Logo: MastercardLogo
}, {
  label: 'American Express',
  Logo: AmexLogo
}, {
  label: 'Apple Pay',
  Logo: ApplePayLogo
}, {
  label: 'Google Pay',
  Logo: GooglePayLogo
}];
export function PaymentMethods({
  className
}: {
  className?: string;
}) {
  return <div className={cn('flex flex-wrap items-center justify-center gap-2', className)} data-id="element-169">
      {methods.map(({
      label,
      Logo
    }) => <Chip key={label} label={label} data-id="element-170">
          <Logo data-id="element-171" />
        </Chip>)}
    </div>;
}